import { ExternalTimeSheetMapping } from '@/types/ExternalTimeSheetMapping';
import { queryApi } from '@/utility/queryApi';

export const getExternalTimeSheetMappings = () =>
  queryApi<ExternalTimeSheetMapping[]>({
    method: 'GET',
    path: '/api/external-time-sheet-mappings',
  });
